

export const ALIGN_BRAND_GRAY = {
  SoftIvory: '#FEFCF4',
  Alabaster: '#F7F5ED',
  BoneWhite: '#F0EDE4',
  PaleParchment: '#E8E1D5',
  WarmGrey: '#D9D3C7',
  Stone: '#CCC5B6',
  MutedTaupe: '#A69D8F',
} as const;

export const ALIGN_BRAND_BLACK = {
  SlateGrey: '#737169',
  DeepUmber: '#4F4C42',
  CharcoalBrown: '#383532',
  DarkOliveBlack: '#1B1802',
} as const;

export const ALIGN_BRAND_YELLOW = {
  DeepOchre: '#9B6C01',
  Goldenrod: '#B18A01',
  MutedBrass: '#C8A833',
  FlaxenYellow: '#E2C86D',
  SoftMaize: '#FDE79C',
  CreamyChiffon: '#FEF5B4',
} as const;

export const ALIGN_BRAND_BLUE = {
  DeepSapphireBlue: '#0062A5',
  SteelBlue: '#3181BF',
  SkyBlue: '#5E9FD3',
  SoftCornflower: '#87BDEB',
  BabyBlue: '#A3D0F9',
  PaleIceBlue: '#BEE5FF',
  WhisperBlue: '#E8F6FF',
} as const;
